import { DataListProps } from './props'

/**
 * Limitation of DataList:
 * - The options of datalist (think of the dropdown list) cant not be styled with CSS.
 * See: https://stackoverflow.com/questions/23042745/scroll-bar-for-datalist-in-html5
 *
 * Alternative for future: implement custom "DataList" and "Options" components that are actually built up from styled
 * div and spans, mainting their own states (filtering of options etc.) and styles.
 * See similar: on <Select /> rr-component.
 */

const DataList = ({ id, values }: DataListProps) => {
    return (
        <datalist id={id}>
            {values.map((o, index) => {
                return (
                    <option key={index} value={o}>
                        {o}
                    </option>
                )
            })}
        </datalist>
    )
}
export default DataList
